var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMarketing48Line = function SvgIconMarketing48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.97 9.48c-.98-.5-2.14-.41-3.02.24l-8.65 6.29h-4.85a5.31 5.31 0 0 0-5.3 5.3v2.8c0 2.82 2.22 5.11 5 5.27V37h3.4v-7.59h1.75l8.65 6.29c.51.37 1.1.56 1.7.56.45 0 .9-.1 1.32-.32.98-.5 1.58-1.49 1.58-2.58v-21.3c0-1.1-.61-2.09-1.58-2.58ZM11.55 24.11v-2.8c0-1.05.85-1.9 1.9-1.9h3.7v6.6h-3.7a1.9 1.9 0 0 1-1.9-1.9Zm16.6 8.26-7.6-5.53v-8.27l7.6-5.53v19.33ZM39.85 21.01h-5v3.4h5v-3.4ZM36.919 12.256l-3.536 3.536 2.404 2.404 3.536-3.536-2.404-2.404ZM35.788 27.217l-2.404 2.405 3.536 3.535 2.404-2.404-3.535-3.536Z",
    fill: "current"
  })));
};
export default SvgIconMarketing48Line;